@import 'styles/variables';

.SortVoteList {
  background: var(--neutral-0);
  padding: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid $grey-20;
  box-shadow: 0px 2px 3px $grey-5;
  border-radius: 4px;
  color: $grey-40;
  cursor: pointer;
  transform: translateX(100%); // push it off of the list so it doesn't obscure the first item's content
}

.SortVoteListContainer {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 0;
  transform: translateY(4px);
  z-index: 1;
  position: relative;
}

// behave as an overlay if inside a column_group column (otherwise you get a scrollbar)
[data-node-type='column_group'] [data-type='column'] .SortVoteList {
  transform: translateX(0);
}
